export const language = {
  zh: {
    'Purchase School': '采购学堂',
    'Entering Resource Hub': '进入采购学堂 >',
  },
  en: {
    'Purchase School': 'Resource Hub',
    'Entering Resource Hub': 'Entering Resource Hub >',
  }
};